/*
*
* @module : UserService
* @file : UserService.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of UserService
*
* Created on : 12-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 19-Oct-2019
*/

import axios from 'axios';
import $ from 'jquery';
const API_URL = 'https://quiz.wanitsch.ch/quiz/quiz_app.php';

class UserService
{
	async addUserRecord(formFields)
	{
		const url = `${API_URL}`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		let session_id = sessionStorage.getItem('session_id');
		let formData  = new FormData();
		formData.append('token','');
		formData.append('command','add_user_record');
		formData.append('session_id',session_id);
		$.each(formFields,function(key,value){
			formData.append(key,value);
		});
		return axios({
			url:url,
			method: 'post',
			data: formData,
			config:{headers:headers}
		}).then(function(response) {
			return response.data;
		}).catch(function(response) {
			return response;
		});
	}
}
export default UserService;
